import { render, staticRenderFns } from "./RedesSociais.vue?vue&type=template&id=878ac910&scoped=true"
import script from "./RedesSociais.vue?vue&type=script&lang=js"
export * from "./RedesSociais.vue?vue&type=script&lang=js"
import style0 from "./RedesSociais.vue?vue&type=style&index=0&id=878ac910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878ac910",
  null
  
)

export default component.exports